import { render } from "./CoursesPage.vue?vue&type=template&id=7d70796c"
import script from "./CoursesPage.vue?vue&type=script&lang=js"
export * from "./CoursesPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__